const adminConstants = {
    ADMIN_LOGIN_REQUEST:'ADMIN_LOGIN_REQUEST',
    ADMIN_LOGIN_SUCCESS:'ADMIN_LOGIN_SUCCESS',
    ADMIN_LOGIN_FAILURE:'ADMIN_LOGIN_FAILURE',

    CLEAR: 'ADMIN_CLEAR',
}

export default adminConstants